import React from "react";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function DevelopersEmailScreen() {
    return (
        <DefaultLayout>
            <DevelopersEmailReport />
        </DefaultLayout>
    );
}

function DevelopersEmailReport() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:admin:developers_email"));

    if (!apiData) return;

    const buttons = (
        <ExportButton
            prms={{
                "main-email_type": apiData.forms_data.main.data.email_type,
                "main-state": apiData.forms_data.main.data.state,
                "main-residence_terr": apiData.forms_data.main.data.residence_terr,
                "main-publish_state": apiData.forms_data.main.data.publish_state,
                "main-genre": apiData.forms_data.main.data.genre,
                "main-contact_lang": apiData.forms_data.main.data.contact_lang,
            }}
        />
    );

    return (
        <CommonCard header={t("Выгрузки по разработчикам")}>
            <RenderForm buttons={buttons} />
        </CommonCard>
    );
}
